<template>
  <v-container id="campuses" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('Corporate/Organization Profile')"
          icon="mdi-office-building"
          class="px-3 py-3 small-icon"
          color="primary"
        >
          <v-form id="form" ref="form" v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12" md="10">
                  <v-text-field
                    :label="$i18n.t('Organization Name(Short)')"
                    v-model="corporate.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="10">
                  <v-text-field
                    :label="$i18n.t('Organization Full Name')"
                    v-model="corporate.fullName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="10">
                  <v-text-field
                    :label="$i18n.t('Unique Id')"
                    v-model="corporate.unique_id"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="10">
                  <div
                    class="subtitle-1 font-weight-light"
                    v-if="corporate.logo"
                  >
                    {{ $i18n.t("Company Logo") }}
                  </div>
                  <v-img
                    :src="corporate.logo"
                    style="height:100px;width:100px;margin-top:10px"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="10">
                  <div
                    class="subtitle-1 font-weight-light"
                    v-if="corporate.thumbnail"
                  >
                    {{ $i18n.t("Company Thumbnail") }}
                  </div>

                  <v-img
                    :src="corporate.thumbnail"
                    style="height:100px;width:100px;margin-top:10px"
                  />
                  <v-file-input
                    chips
                    @change="handleFileUpload()"
                    v-model="file"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>

            <v-col cols="12" class="text-right">
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!valid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doPost, doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  url = "/api/corp/profile/data";
  profile = {
    email: "",
  };
  file = null;
  corporateConfig = {};
  entity = {
    address: {
      country: "India",
      city: "",
      state: "",
      addressLine: "",
    },
  };
  corporate = "";
  sendCode = false;
  code = "";
  newEmail = "";
  value = "";
  valid = true;
  validationrules = {
    password: [(v) => !!v || this.$i18n.t("Password is required")],
    newEmail: [(v) => !!v || this.$i18n.t("New Email is required")],
  };
  items = ["Male", "Female", "Other"];

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.profile = await doGet(this.url);
      this.corporate = this.profile.corporate;
      if (this.profile.entity && !this.profile.entity.address) {
        this.profile.entity.address = {};
      }
      this.entity = this.profile.entity;
      this.corporateConfig = this.profile.corporateConfig;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async save() {
    try {
      common.setLoading(true);
      this.profile.corporate = this.corporate;
      this.profile.entity = this.entity;
      this.profile.corporateConfig = this.corporateConfig;
      await doPost("/api/corp/profile/save", this.profile);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
#bookingCheckbox {
  margin-left: 20px;
  margin-right: 20px;
  justify-content: space-between;
}
</style>
